<template>
    <span v-b-tooltip.hover :title="dateTime">
        {{ date }}
    </span>
</template>
<script>
    import moment from 'moment';
    moment.locale('NL');
    export default {
        props: ['value', 'meta'],

        data() {
            return {
                moment: null,
            }
        },

        created() {
            this.moment = moment(this.value.value);
        },

        computed: {
            date() {
                return this.moment.format(this.meta.format.date);
            },
            dateTime() {
                if(this.meta.noTooltip){
                    return null;
                }

                return this.moment.format(this.meta.format.dateTime);
            }
        }
    }
</script>
